<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="postId" >
        <span slot="label" ><a-tooltip>{{ $t('帖子ID，外键{community_group_post.id}') }}<template slot="title">{{ $t('帖子ID，外键{community_group_post.id}') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.postId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'帖子ID，外键{community_group_post.id}'" />
      </a-form-model-item>
      <a-form-model-item prop="topicId" >
        <span slot="label" ><a-tooltip>{{ $t('话题ID，外键{community_group_topic.id}') }}<template slot="title">{{ $t('话题ID，外键{community_group_topic.id}') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.topicId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'话题ID，外键{community_group_topic.id}'" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" ><a-tooltip>{{ $t('备注') }}<template slot="title">{{ $t('备注') }}</template></a-tooltip> </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getCommunityGroupPostTopic, addCommunityGroupPostTopic, updateCommunityGroupPostTopic } from '@/api/community/communityGroup/communityGroupPostTopic'
  import { mapGetters } from 'vuex'
  import CustomDictTag from '@/components/DictCustomTag'
  import { generateFilePath, uploadObject } from '@/api/tool/oss'
  import LocaleFieldButton from '@/components/locale/LocaleFieldButton.vue'
  import moment from 'moment'

  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        postId: null,
        topicId: null,
        remark: null,
        localeFieldMap: {}
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
          postId: [{ required: true, message: this.$t('帖子ID，外键{community_group_post.id}') + this.$t('不能为空'), trigger: 'blur' }],
          topicId: [{ required: true, message: this.$t('话题ID，外键{community_group_topic.id}') + this.$t('不能为空'), trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    moment,
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        postId: null,
        topicId: null,
        remark: null,
        localeFieldMap: {}
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCommunityGroupPostTopic({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCommunityGroupPostTopic(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addCommunityGroupPostTopic(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
